import { render, staticRenderFns } from "./rp-roles-datasources-multi-edit.vue?vue&type=template&id=1d931c90"
import script from "./rp-roles-datasources-multi-edit.vue?vue&type=script&lang=js"
export * from "./rp-roles-datasources-multi-edit.vue?vue&type=script&lang=js"
import style0 from "./rp-roles-datasources-multi-edit.vue?vue&type=style&index=0&id=1d931c90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports